import {createContext} from "react";

export const LayoutHeaderContext = createContext<boolean>(false);
